import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal,SGeneralForms } from 'shj-components'
import { chargebackRelationshipSaveOrUpdate,chargebackRelationshipById } from '@/services/fmsConfig'
import { getEnum,httpDictServTenant } from '@/services/fmsServices'
import { message, Spin } from 'antd';
// @ts-ignore
export function modalAddOrEditFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest?.isLook ? '查看' : rest?.id ? '编辑' : '新增'}`,
    width: 900,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
// @ts-ignore
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const reqMeg = '不能为空';
  const formRef: any = useRef();
  useEffect(() => {
    initFn();
  }, []);
  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }
  const initFn = () => {
    if (rest?.id) {
      // 回显数据
      setAddOrEditFooterLoading(true)
      chargebackRelationshipById(rest.id).then(res => {
        const relevanceTransactionTypeList = res.relevanceTransactionTypeList.map(item => item.value);
        const transferMoneyBetweenOrders =  rest?.isLook ? res.transferMoneyBetweenOrders === '1' ? '是' : '否' : res.transferMoneyBetweenOrders === '1' ? true : false
        onFormRef()?.setFieldsValue({...res, relevanceTransactionTypeList,transferMoneyBetweenOrders, refundableType: res.refundableType === '0' ? 0 : 1 });
        setAddOrEditFooterLoading(false)
      }).catch(err => {
        setAddOrEditFooterLoading(false)
      })
    }
  };
  // 重置
  // const onReset = () => {
  //   form.resetFields();
  // };
  const onSubmit = (values:any) => {
    setAddOrEditFooterLoading(true)
    values.transferMoneyBetweenOrders = values.transferMoneyBetweenOrders ? 1 : 0
    const relevanceTransactionTypeList = values.relevanceTransactionTypeList.map(key => ({ value: key }));
    chargebackRelationshipSaveOrUpdate({ ...values, relevanceTransactionTypeList })
      .then(res => {
        setAddOrEditFooterLoading(false)
        message.success('操作成功')
        onClose()
        fn()
      }).catch(err => {
        setAddOrEditFooterLoading(false)
      })
  };
  const getOptions = async () => {
    // let refundTypeList = await getEnum('com.shj.saas.plus.fms.enums.RefundTypeEnum') //退款类型
    // let paymentTypeList = await getEnum('com.shj.saas.plus.fms.enums.PaymentTypeEnum') //关联交易类型
    setAddOrEditFooterLoading(true)
    let refundTypeList = await httpDictServTenant({ parentKey: 'refundType', enabled: 1 })//退款类型
    let paymentTypeList = await httpDictServTenant({ parentKey: 'transactionFeeType', enabled: 1 })//关联交易类型
    let billStatusList = await getEnum('com.shj.saas.plus.fms.enums.BillStatusEnum') //单据状态
    setAddOrEditFooterLoading(false)
    return Promise.resolve({
      amountReceivedList: [
        { label: '按收款金额', value: 0 },
        { label: '按收款未核销金额', value: 1 },
      ],
      refundTypeList,
      paymentTypeList,
      billStatusList,
    })
  }
  return (
    <Spin spinning={addOrEditFooterLoading}>
    <div style={{ padding: 15 }}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        isFooterBtn={rest?.isLook ? false : true}
        isDetail={rest?.isLook ? true : false}
        footerAlign="right"
        onFinish={onSubmit}
        isHideResetBtn={true}
        isHideGobackBtn={true}
        layout="vertical"
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              // {
              //   label: '编码',
              //   name: 'code',
              //   spanCol: 12,
              //   required: true,
              //   rules: [{ required: true, message: reqMeg }],
              //   isHideItem: !rest?.id,
              //   comConfig: {
              //     disabled: true
              //   },
              // },
              {
                label: '退款类型',
                name: 'refundType',
                spanCol: 12,
                type: 'select',
                data: 'refundTypeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                },
              },
              {
                label: '单据状态',
                type: 'select',
                name: 'billStatus',
                spanCol: 12,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                data: 'billStatusList',
                comConfig: {
                  fieldNames: { value: 'key', label: 'description' },
                },
              },
              {
                label: '关联交易类型',
                name: 'relevanceTransactionTypeList',
                spanCol: 12,
                type: 'select',
                data: 'paymentTypeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                  mode: 'multiple',
                },
              },
              {
                label: '可退余额取值来源',
                name: 'refundableType',
                spanCol: 12,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                type: 'radio',
                data: 'amountReceivedList',
              },
              {
                label: '是否订单间转款',
                name: 'transferMoneyBetweenOrders',
                isHideItem: rest?.isLook,
                spanCol: 12,
                type: 'switch',
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
              {
                label: '是否订单间转款',
                name: 'transferMoneyBetweenOrders',
                isHideItem: !rest?.isLook,
                spanCol: 12,
              },
            ],
          },
        ]}
      />
    </div>
    </Spin>
  );
};
